import { render } from "./SellerInfo.vue?vue&type=template&id=ec5800a2&scoped=true"
import script from "./SellerInfo.vue?vue&type=script&lang=js"
export * from "./SellerInfo.vue?vue&type=script&lang=js"

import "./SellerInfo.vue?vue&type=style&index=0&id=ec5800a2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec5800a2"]])

export default __exports__